// extracted by mini-css-extract-plugin
export default {"header":"Header_header__xBtbA","user":"Header_user__cfPLO","activeMenu":"Header_activeMenu__6WBIf","rightMenu":"Header_rightMenu__qUwMC","logo":"Header_logo__LFDMx"};